import React from "react";
import styled from "styled-components";
import { useTip } from "../ui/Tooltip/Tooltip";
import { CHART_COLORS } from "../../styles/theme";

/**
 * Donut SVG.
 * segments : [{ value, color, tip? }]
 * center / sub : textes au centre ; centerTip : tooltip sur le texte central
 */
const Donut = ({
    segments = [],
    center = "",
    sub = "",
    size = 136,
    centerTip,
}) => {
    const tip = useTip();
    const total = segments.reduce((a, s) => a + s.value, 0) || 1;
    const r = 48;
    const C = 2 * Math.PI * r;
    let offset = 0;

    return (
        <svg viewBox="0 0 120 120" width={size} height={size} role="img">
            {segments.map((seg, i) => {
                const len = (seg.value / total) * C;
                const el = (
                    <circle
                        key={`seg-${i}`}
                        r={r}
                        cx="60"
                        cy="60"
                        fill="none"
                        stroke={seg.color}
                        strokeWidth="15"
                        strokeDasharray={`${len} ${C - len}`}
                        strokeDashoffset={-offset}
                        transform="rotate(-90 60 60)"
                        {...tip(seg.tip)}
                    />
                );
                offset += len;
                return el;
            })}
            {center !== "" && (
                <CenterText
                    x="60"
                    y={sub ? 57 : 64}
                    textAnchor="middle"
                    fontSize="16"
                    fontWeight="600"
                    fill={CHART_COLORS.ink}
                    className={centerTip ? "hoverable" : ""}
                    {...tip(centerTip)}
                >
                    {center}
                </CenterText>
            )}
            {sub && (
                <text
                    x="60"
                    y="72"
                    textAnchor="middle"
                    fontSize="8"
                    fill={CHART_COLORS.muted2}
                >
                    {sub}
                </text>
            )}
        </svg>
    );
};

export default Donut;

const CenterText = styled.text`
    cursor: default;
    transition: fill 0.1s;
    &.hoverable:hover {
        fill: var(--prh-violet-dark);
    }
`;
